import './EditBookingModal.css';
import { React, useEffect, PropTypes, DateTime, useCallback, DatePicker, Option, Select, Locale, dayjs, moment } from '../../../../libraries';
import { CustomModal } from '../../../../common';
import { getBookingById } from '../../../../services';
import { useEditBooking } from '../../../component';
import { dynamicTimeZone } from '../../../../customHooks';

const EditBooking = ({
  setLoader,
  teamMemberArrayForm,
  blankFeild,
  services,
  customers,
  isNewBooking,
  id,
  bookings,
  setBookings,
  closeEditBookingModal,
}) => {
  const { t } = Locale();
  const {
    setFormErrors,
    handleChangeNewBooking,
    onChange,
    formErrorsNewBooking,
    formValuesNewBooking,
    handleSubmitBooking,
    formValues,
    setFormValues,
    handleChange,
    handleSubmit,
    setFormErrorsNewBooking,
    setFormValuesNewBooking,
    onChangeNewBooking,
    formErrors,
    vendorOpenignHoursFunction,
    timeSlots,
    setDayName,
    setSelectedDateobj,
    vendorOpenignHours,
    handleDateSelect,
    setSelectedBookingData,
    generateTimeSlots,
    setSelectedDateObj
  } = useEditBooking({
    id,
    bookings,
    setBookings,
    closeEditBookingModal,
    setLoader,
  });

  const editBooking = async () => {
    const showBooking = await getBookingById(id);
    const bookingTime = showBooking.data.booking_service.booking_time;
    const bookingDate = showBooking.data.booking_service.booking_date;
    const dateTimeInBangkok = DateTime.fromISO(bookingTime, {
      zone: dynamicTimeZone(),
    });
    const formattedTime = dateTimeInBangkok.toFormat('HH:mm');
    setFormValues({
      customerName: showBooking.data.customer_name,
      serviceName: showBooking.data.service_name_en,
      duration: showBooking.data.duration,
      listedPrice: showBooking.data.booking_service.price,
      paidAmount: showBooking.data.paid_amount,
      discount: showBooking.data.total_discount,
      paymentType: showBooking.data.payment_type,
      status: showBooking.data.booking_service.status,
      scheduleDate: bookingDate,
      teamMember: showBooking.data.booking_service.team_member_id || '',
      scheduleTime: formattedTime,
    });


    const dateObj = new Date(bookingDate);
    setSelectedDateObj(dateObj)
    const formattedDate = DateTime.fromJSDate(dateObj).toFormat('yyyy-MM-dd');
    setSelectedDateobj(formattedDate)
    const options = { weekday: 'long' };
    const dayName = dateObj
      .toLocaleDateString('en-US', options)
      .toLocaleLowerCase();
    setDayName(dayName);

    if (showBooking.data.vendor_business_hours) {
      vendorOpenignHoursFunction(showBooking.data.vendor_business_hours);
    }
    setSelectedBookingData(showBooking?.data);
    generateTimeSlots(showBooking?.data)
  };

  const setFormErrorsFun = () => {
    setFormErrors({
      customerName: '',
      serviceName: '',
      duration: '',
      listedPrice: '',
      paidAmount: '',
      discount: '',
      paymentType: '',
      status: '',
      scheduleDate: '',
      teamMember: '',
    });
  };

  useEffect(() => {
    setFormErrorsFun();
    editBooking();
  }, [id]);

  const setFormValuesAndErr = useCallback(() => {
    setFormValuesNewBooking({
      customerName: '',
      serviceName: '',
      duration: '',
      listedPrice: '',
      paidAmount: '',
      discount: '',
      paymentType: 'online',
      status: 'confirmed',
      scheduleDate: '',
      teamMember: '',
      time: '',
    });
    setFormErrorsNewBooking({
      customerName: '',
      serviceName: '',
      duration: '',
      listedPrice: '',
      paidAmount: '',
      discount: '',
      paymentType: '',
      status: '',
      scheduleDate: '',
      teamMember: '',
      time: '',
    });
  }, [setFormErrorsNewBooking, setFormValuesNewBooking]);

  useEffect(() => {
    setFormValuesAndErr();
  }, [blankFeild, setFormValuesAndErr]);


  return (
    <>
      <CustomModal
        text={
          <form className="form">
            <div className="edit-booking-header">
              <h5 className="title">{t('venderBooking.editBooking')}</h5>
            </div>
            <div className="container mt-2">
              <div className="row">
                <div className="form-group mt-2 col-md-6 col-12">
                  <label className="width100">
                    <span className="">
                      {t('venderBooking.scheduledDate')}
                    </span>
                    <span className="custom-estric">*</span>
                  </label>
                  <DatePicker
                    placeholder="Select Date"
                    onChange={handleDateSelect}
                    value={
                      formValues?.scheduleDate &&
                      dayjs(formValues?.scheduleDate, {
                        format: 'YYYY-MM-DD',
                      })
                    }
                    disabledDate={(current) => {
                      if (current && current < moment().startOf('day')) {
                        return true;
                      }
                      if (
                        (current &&
                          !vendorOpenignHours?.sunday &&
                          current.day() === 0) ||
                        (!vendorOpenignHours.monday && current.day() === 1) ||
                        (!vendorOpenignHours.tuesday &&
                          current.day() === 2) ||
                        (!vendorOpenignHours.wednesday &&
                          current.day() === 3) ||
                        (!vendorOpenignHours.thursday &&
                          current.day() === 4) ||
                        (!vendorOpenignHours.friday && current.day() === 5) ||
                        (!vendorOpenignHours.saturday && current.day() === 6)
                      ) {
                        return true;
                      } else {
                        return false;
                      }
                    }}
                    className="user-profile-date-picker-ant form-control mt-1"
                  />
                  <div className="error">{formErrors?.scheduleDate}</div>
                </div>
                <div className="form-group mt-2 col-lg-6 col-md-6 col-12">
                  <label>
                    <span>{t('ServiceField.time')}</span>
                    <span className="custom-estric">*</span>
                  </label>
                  <Select
                    value={formValues?.scheduleTime}
                    onChange={(value) => handleChange('scheduleTime', value)}
                    className="mt-1 user-edit-booking-time-dropdown"
                    placeholder="Select Schedule Time"
                  >
                    {timeSlots &&
                      timeSlots.map((time, index) => (
                        <Select.Option key={index} value={time}>
                          {time}
                        </Select.Option>
                      ))}
                  </Select>
                  <div className="error">{formErrors?.scheduleTime}</div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group mt-2 col-12">
                    <label>
                      <span>{t('venderBooking.teamMember')}</span>
                      <span className="custom-estric">*</span>
                    </label>
                    <Select
                      placeholder={t('calender.selectTeamMember')}
                      value={formValues?.teamMember || undefined}
                      onChange={onChange}
                      className="vendor-edit-ant-select-form mt-1"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {teamMemberArrayForm &&
                        teamMemberArrayForm.map((item) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.full_name}
                          </Select.Option>
                        ))}
                    </Select>
                    <div className="error">{formErrors?.teamMember}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group mt-5">
              <center>
                <input
                  type="button"
                  value={t('button.cancelButton')}
                  className="form-cancel-booking"
                  onClick={closeEditBookingModal}
                />
                <input
                  disabled={formValues?.status === 'cancelled_by_customer'}
                  type="submit"
                  onClick={handleSubmit}
                  value={t('button.update')}
                  className="form-submit-booking"
                />
              </center>
            </div>
          </form>
        }
      />
    </>
  );
};
EditBooking.propTypes = {
  teamMemberArrayForm: PropTypes.array,
  blankFeild: PropTypes.any,
  services: PropTypes.array,
  customers: PropTypes.array,
  isNewBooking: PropTypes.bool,
  id: PropTypes.number,
  bookings: PropTypes.array,
  setBookings: PropTypes.func,
  closeEditBookingModal: PropTypes.func,
};
export default EditBooking;